import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { BillingPlan } from '../../services/api'
import { PlanCard } from './PlanCard'

export interface PlanSelectionGridProps {
  plans?: BillingPlan[]
  onSelectPlan: (planType: string) => void
  loading?: boolean
  title?: string
  subtitle?: string
}

export const PlanSelectionGrid: React.FC<PlanSelectionGridProps> = ({
  plans = [],
  onSelectPlan,
  loading = false,
  title = 'Choose the right plan for your business',
  subtitle = 'Flexible pricing options designed to automate customer interactions and scale your WhatsApp marketing.',
}) => {
  const sortedPlans = [...plans].sort((a, b) => {
    const orderA = a.display_metadata?.display_order ?? 99
    const orderB = b.display_metadata?.display_order ?? 99
    return orderA !== orderB ? orderA - orderB : a.amount_subunits - b.amount_subunits
  })

  const count = sortedPlans.length || 2
  const gridSize = count === 1 ? { xs: 12 } : count === 2 ? { xs: 12, sm: 6 } : { xs: 12, sm: 6, md: 4 }

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', py: 1, px: 2 }}>
      {title && (
        <Box sx={{ textAlign: 'center', mb: 6, mt: 2 }}>
          <Typography variant="h4" fontWeight={900} sx={{ letterSpacing: '-0.02em', mb: 1 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 500, mx: 'auto' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}

      <Grid container spacing={3} alignItems="stretch" justifyContent="center">
        {sortedPlans.map((plan) => (
          <Grid item {...gridSize} key={plan.plan_type}>
            <PlanCard
              plan={plan}
              onSelectPlan={onSelectPlan}
              loading={loading}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
